import { getDiscountEndDate } from "./registrationDiscountDates";

/** Display amount on JazakAllah step after successful registration checkout. */
export const REGISTRATION_PAID_MEMBERSHIP_PRICE_KEY =
  "registration_confirmed_membership_price";

export function persistRegistrationPaidMembershipPrice(amount: number): void {
  if (!Number.isFinite(amount) || amount < 0) return;
  try {
    sessionStorage.setItem(
      REGISTRATION_PAID_MEMBERSHIP_PRICE_KEY,
      String(amount),
    );
  } catch {
    /* private browsing */
  }
}

export function readRegistrationPaidMembershipPrice(): number | null {
  try {
    const raw = sessionStorage.getItem(REGISTRATION_PAID_MEMBERSHIP_PRICE_KEY);
    if (!raw) return null;
    const n = parseFloat(raw);
    return Number.isFinite(n) && n >= 0 ? n : null;
  } catch {
    return null;
  }
}

export function clearRegistrationPaidMembershipPrice(): void {
  try {
    sessionStorage.removeItem(REGISTRATION_PAID_MEMBERSHIP_PRICE_KEY);
  } catch {
    /* ignore */
  }
}

/** Discount end dates on FormData (same rules as membership checkout). */
export function appendRegistrationDiscountDates(
  formData: FormData,
  discountCode: string,
) {
  if (!discountCode) return;
  const endDate = getDiscountEndDate(discountCode);
  if (endDate) {
    formData.append("discountEndDate", endDate.toISOString());
  }
}

export function buildRegistrationFormDataAfterPayment(options: {
  effectiveObjectId: string;
  userData: Record<string, unknown>;
  discountCode: string;
  /** Selected plan at checkout — overrides stale localStorage user profile on upgrade. */
  membershipName?: string;
  membershipId?: number;
  isAnnualMembership?: number;
}): FormData {
  const formData = new FormData();
  const mergedForSave: Record<string, unknown> = {
    ...options.userData,
    objectId: options.effectiveObjectId,
  };
  if (options.membershipName?.trim()) {
    mergedForSave.membershipName = options.membershipName.trim();
  }
  if (options.membershipId != null && options.membershipId > 0) {
    mergedForSave.membershipId = options.membershipId;
  }
  if (options.isAnnualMembership != null) {
    mergedForSave.isAnnualMembership = options.isAnnualMembership;
  }
  Object.entries(mergedForSave).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, String(value));
    }
  });
  formData.append("hasPaid", "1");
  const codeForDiscount =
    (typeof mergedForSave.discountCode === "string"
      ? mergedForSave.discountCode
      : "") || options.discountCode || "";
  if (codeForDiscount) {
    appendRegistrationDiscountDates(formData, codeForDiscount);
  }
  return formData;
}
